<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" [style]="{ color: color }">
  <rect x="0" y="0" width="24" height="4" />
  <rect x="0" y="6" width="24" height="10" />
  <rect x="0" y="18" width="24" height="4" />
</svg>
